<script>
import isEqual from 'lodash.isequal'
export default {
    name: 'InputRadio',
    props: {
        value: null,
        data: null,
        hintText: null,
        content: undefined,
        required: Boolean,
        disabled: Boolean,
        readonly: Boolean,
        allowEmpty: Boolean,
    },

    data() {
        return {
            innerValue: null,
        }
    },

    computed: {
        checked() {
            return isEqual(this.innerValue, this.data)
        },
    },

    watch: {
        value: {
            immediate: true,
            handler(val) {
                this.innerValue = val
            },
        },
    },

    methods: {
        toggle() {
            if (!this.disabled && !this.readonly) {
                if (this.allowEmpty && this.innerValue) {
                    this.$set(this, 'innerValue', null)
                    this.$emit('input', null)
                } else {
                    this.$emit('input', this.data)
                }
            }
        },
    },
}
</script>

<template lang="pug">
.radio-wrapper(tabindex="0" aria-role="szar" @click.stop="toggle" :class="{'checked': checked, 'disabled': disabled, 'readonly': readonly}")
    .radio
        input(
            :id="_uid"
            :required="required"
            :disabled="disabled"
            :readonly="readonly"
            type="hidden")

        span.radio-icon
            transition(name="fade-radio")
                icon(icon="fa-solid fa-circle")

        small.radio-text(v-if="content" v-html="content")
        small.radio-text(v-else-if="$slots.default")
            slot
        sup(v-if="required") *

    .hint(v-if="hintText" :class="{ 'text-error': hasError }")
        | {{ hintText }}

</template>
